import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@shared/guards/auth.service';

import { MRIEditerComponent } from './MRIEditer.component';
import { MRIEditerResolver } from './MRIEditer.resolver';
import { ExitGuard } from '../shared/guards/exit-guard.service';

export const MRIEditerRoutes: Routes = [
  {
    path: ':id/patientviewer',
    children: [
      { path: '**', canDeactivate: [ExitGuard], component: MRIEditerComponent },
    ],
    resolve: {
      MRIEditerResolver,
    },
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(MRIEditerRoutes)],
})
export class MRIEditerRoutingModule {}
